import * as PaymentsConstants from '../../constants';
import * as D from '../../deps';
import * as Workers from '../workers';

export default [
  {
    actionType: D.Constants.Listener.ListenerActions.LISTENER_AUTHENTICATED,
    handler: Workers.Payment.onListenerAuthenticated,
    concur: 'takeLatest',
  },
  {
    actionType: PaymentsConstants.Actions.ANONYMOUS_START_TRIAL_CLICKED,
    handler: Workers.Payment.anonymousStartTrialClicked,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.LOAD_PAYMENTS_DATA,
    handler: Workers.Payment.loadPaymentsData,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.GET_SUBSCRIPTION_INFO_V2,
    handler: Workers.Payment.getSubscriptionInfoV2,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.GET_SUBSCRIPTION_INFO_V2_SUCCESS,
    handler: Workers.Payment.onGetSubscriptionInfoV2Success,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.GET_CREDIT_CARD_V2,
    handler: Workers.Payment.getCreditCardV2,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.CANCEL_SUBSCRIPTION,
    handler: Workers.Payment.cancelSubscription,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.DELETE_CREDIT_CARD,
    handler: Workers.Payment.deleteCreditCard,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.RESUBSCRIBE,
    handler: Workers.Payment.resubscribe,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.GET_AVAILABLE_PRODUCTS,
    handler: Workers.Payment.getAvailableProducts,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.UPDATE_CREDIT_CARD_INFO,
    handler: Workers.Payment.updateCreditCardInfo,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.UPDATE_BILLING_INFO_V2_SUCCESS,
    handler: Workers.Payment.updateBillingInfoSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.ACQUIRE_PRODUCT_SUCCESS,
    handler: Workers.Payment.onAcquireProductSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.CANCEL_CURRENT_PRODUCT,
    handler: Workers.Payment.cancelCurrentProduct,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.CANCEL_CURRENT_PRODUCT_SUCCESS,
    handler: Workers.Payment.cancelCurrentProductSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.FAMILY_PLAN_EXIT_SUCCESS,
    handler: Workers.Payment.cancelCurrentProductSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.EXIT_FROM_FAMILY_PLAN,
    handler: Workers.Payment.exitFromFamilyPlan,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.FAMILY_PLAN_CREATE_INVITE,
    handler: Workers.Payment.createFamilyPlanInvite,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.FAMILY_PLAN_RESEND_INVITE,
    handler: Workers.Payment.resendFamilyPlanInvite,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.FAMILY_PLAN_REVOKE_INVITE,
    handler: Workers.Payment.revokeFamilyPlanInvite,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.FAMILY_PLAN_REMOVE_CHILD,
    handler: Workers.Payment.removeChildFromFamilyPlan,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.FAMILY_PLAN_CREATE_INVITE_SUCCESS,
    handler: Workers.Payment.createFamilyPlanSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.FAMILY_PLAN_RESEND_INVITE_SUCCESS,
    handler: Workers.Payment.resendFamilyPlanSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.FAMILY_PLAN_REVOKE_INVITE_SUCCESS,
    handler: Workers.Payment.revokeFamilyPlanInviteSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.FAMILY_PLAN_REMOVE_CHILD_SUCCESS,
    handler: Workers.Payment.removeChildFromFamilyPlanSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.FAMILY_PLAN_EXIT_SUCCESS,
    handler: Workers.Payment.loadPaymentsData,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.REQUEST_PARTNER_UPGRADE,
    handler: Workers.Payment.onRequestPartnerUpgrade,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.PROCESS_UPGRADE_AUTHENTICATION,
    handler: Workers.Payment.onProcessUpgradeAuthentication,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.PROCESS_UPGRADE,
    handler: Workers.Payment.onProcessUpgrade,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.ENTER_PARTNER_UPGRADE_FLOW,
    handler: Workers.Payment.onEnterPartnerUpgradeFlow,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.INITIATE_PARTNER_UPGRADE,
    handler: Workers.Payment.onInitiatePartnerUpgrade,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.ENTER_SUBSCRIPTION_MANAGEMENT,
    handler: Workers.Payment.onEnterSubscriptionManagement,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.ENTER_FAMILY_PLAN_MANAGEMENT,
    handler: Workers.Payment.onEnterFamilyPlanManagement,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.OPEN_SWITCH_PLAN_MODAL,
    handler: Workers.Payment.onOpenSwitchPlanModal,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.OPEN_CANCEL_SUBSCRIPTION_MODAL,
    handler: Workers.Payment.onOpenCancelSubscriptionModal,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.SWITCH_PLAN,
    handler: Workers.Payment.onSwitchPlan,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.PAYPAL_COMPLETE,
    handler: Workers.Payment.onEnterPaypalComplete,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.ANON_LOGIN_SUCCESS,
    handler: Workers.Payment.onAnonLoginSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.ACQUIRE_OFFER,
    handler: Workers.Payment.onAcquireOffer,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.PREPARE_TO_ACQUIRE_OFFER,
    handler: Workers.Payment.onPrepareToAcquireOffer,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.SELECT_PAYMENT_PROVIDER,
    handler: Workers.Payment.onSelectPaymentProvider,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.WAIT_FOR_SUBSCRIPTION_INFO,
    handler: Workers.Payment.onWaitForSubscriptionInfo,
    concur: 'takeOnly',
  },
  {
    actionType: PaymentsConstants.Actions.REVERIFY_LINK_CLICKED,
    handler: Workers.Payment.OnReverifyLinkClicked,
    concur: 'takeOnly',
  },
];
